import { render, staticRenderFns } from "./appManageDetail.vue?vue&type=template&id=b91841e0"
import script from "./appManageDetail.vue?vue&type=script&lang=js"
export * from "./appManageDetail.vue?vue&type=script&lang=js"
import style0 from "./appManageDetail.vue?vue&type=style&index=0&id=b91841e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports